import React from 'react';
import Container from '../Layout/Container';
import { Box } from '../Layout';
import { Link } from '../Typography';

const Contact = () => (
  <Container>
    <Box>
      <h2>Staff</h2>
      <p>We are excited to announce our volunteer national staff for 2024:</p>
      <p><strong>Mens Blind Football </strong><br />National Performance Director - Dave Connolly (VIC)<br />Coach - Jun Fujii (NSW)<br />Assistant Coach - Stephen Murray (QLD)<br />Goal Guide/Assistant Coach - Conor Mcateer (NSW)</p>
      <p><strong>Womens Blind Football </strong><br />Coach - Bess Hepworth (SA)<br />Assistant Coach - TBC<br />National Coordinator - TBC <br />Goal Guide/Assistant Coach - Andrew Whisson (SA)</p>
      <p><strong>Partially Sighted Futsal </strong><br />National Coordinator - TBC (SA)<br />Coach - TBC </p>
    </Box>

     <h1>Mens Blind Football</h1>
      <p>You can contact us at <Link
        href='mailto:football@blindsportsaustralia.com.au?Subject=Website%20Query'
        target='_top'
        aria-label='Email Mens Blind Football Australia'
      >football@blindsportsaustralia.com.au</Link>
      </p>

     <h1>Womens Blind Football</h1>
      <p>You can contact us at <Link
        href='mailto:womensfootball@blindsportsaustralia.com.au?Subject=Website%20Query'
        target='_top'
        aria-label='Email Womens Blind Football Australia'
      >womensfootball@blindsportsaustralia.com.au</Link>
      </p>

     <h1>Partially Sighted Futsal</h1>
      <p>You can contact us at <Link
        href='mailto:futsal@blindsportsaustralia.com.au?Subject=Website%20Query'
        target='_top'
        aria-label='Email Partially Sighted Futsal Australia'
      >futsal@blindsportsaustralia.com.au</Link>
      </p> or Facebook direct messaging: @ausblindfootball
  </Container>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact/Contact.js